module.exports = __webpack_public_path__ + "img/lottery_tcg_lotto.f9d2aab9.png";